import React, { useState, useEffect } from "react";
import { Grid, Typography, Card, CardContent, IconButton } from "@material-ui/core";
import { ArrowBackIos, ArrowForwardIos} from "@material-ui/icons";
import { Line } from "react-chartjs-2";
import moment from "moment";
import ecgJsonData from "./EcgData.json";
import "./EcgChart.css";

export default function EcgChart({ deviceId, beneficiaryId }) {
  const [ecgData, setEcgData] = useState([]);
  const [currentDate, setCurrentDate] = useState(moment());

  useEffect(() => {
    setEcgData(ecgJsonData.body.signal);
  }, [deviceId, beneficiaryId, currentDate]);

  const data = {
    labels: Array.from({ length: ecgData.length }, (_, i) => i),
    datasets: [
      {
        label: "ECG",
        data: ecgData,
        fill: false,
        borderColor: "rgb(67, 184, 184)",
        borderWidth: 1.5,
        pointRadius: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          display: false,
          gridLines: {
            display: true,
            color: "rgba(0, 0, 0, 0.05)",
          },
        },
      ],
      yAxes: [
        {
          display: false,
          gridLines: {
            display: true,
            color: "rgba(0, 0, 0, 0.05)",
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    tooltips: {
      enabled: false,
    },
  };

  const handlePrevDate = () => setCurrentDate(moment(currentDate).subtract(1, "days"));
  const handleNextDate = () => setCurrentDate(moment(currentDate).add(1, "days"));

  return (
    <Card variant="outlined" className="ecg-card">
      <CardContent>
        <Grid container alignItems="center" justify="center" className="ecg-header-grid">
          <Grid item>
            <Typography variant="subtitle1" className="ecg-title">
              ECG
            </Typography>
          </Grid>
        </Grid>
        <Grid container alignItems="center" justify="center" spacing={2} className="ecg-date-grid">
          <Grid item>
            <IconButton size="small" onClick={handlePrevDate}>
              <ArrowBackIos fontSize="small" />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography variant="body2">{currentDate.format("DD/MM/YY, HH:mm")}</Typography>
          </Grid>
          <Grid item>
            <IconButton size="small" onClick={handleNextDate}>
              <ArrowForwardIos fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>

        <div className="ecg-scroll-wrapper">
          <div className="ecg-chart-container">
            <div className="ecg-chart-background"></div>
            <Line data={data} options={options} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
